// Added By Farhan Khan Khan on 24-Dec-2025
import React, { useState, useEffect } from "react";
import { Badge, Button, Card, Col, Container, Row } from "react-bootstrap";
import Confirm from "../Confirm";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import solisPowerApi from "../../api/solisPowerApi";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import FilesCreate from "../file/FilesCreate";
import RelatedListFiles from "../file/RelatedListFiles";
import Path from "../common/Path";
import moment from "moment";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";
import * as constants from "../../constants/CONSTANT";
import PubSub from "pubsub-js";
import jwt_decode from "jwt-decode";
import Helmet from "react-helmet";
import Main from "../layout/Main";
import Image from "react-bootstrap/Image";
import Permissionhelper from "../common/Permissionhelper";
import { formatDate, formatDateForCreatedDate, formatDateForView, getUserDetails } from "../../utils/helper";
import PERMISSIONS from "../../constants/permissions";

const ProductView = (props) => {
  const userInfo = getUserDetails();
  const location = useLocation();
  const navigate = useNavigate();
  const [product, setProduct] = useState(location.state ? location.state : {});
  const [data, setData] = useState([]);
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    fetchProduct();
  }, []);

  const fetchProduct = () => {
    if (!product.id && location.hasOwnProperty("pathname") && location.pathname.split("/").length >= 3) {
      product.id = location.pathname.split("/")[2];
    }

    async function initProduct() {
      try {
        let result = await solisPowerApi.fetchProductById(product.id);

        if (result) {
          setProduct(result);
        } else {
          setProduct({});
        }
      } catch (error) {
        console.error("Error fetching product:", error);
      }
    }

    initProduct();
  };

  const deleteProduct = async () => {
    const result = await solisPowerApi.deleteProduct(location?.state.id ? location?.state.id : product?.id);
    if (result) {
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Deleted ",
        message: "Record Deleted successfully",
      });
      navigate(`/products`);
    }
  };

  const editProduct = () => {
    navigate(`/products/${product.id}/e`, { state: product });
  };

  return (
    <Main>
      <Container>
        {product && (
          <>
            {modalShow && (
              <Confirm
                show={modalShow}
                onHide={() => setModalShow(false)}
                deleteProduct={deleteProduct}
                title="Confirm delete?"
                message="You are going to delete the record. Are you sure?"
                table="Product"
              />
            )}
            <Row className="view-form">
              <Col lg={11} className="pb-3 pt-2">
                <Link className="nav-link" to="/products">
                  Home <i className="fa-solid fa-chevron-right"></i>{" "}
                  <div style={{ color: "#23468c", display: "inline" }}>
                    Product
                  </div>
                </Link>
              </Col>
              <Col></Col>
            </Row>
            <Row className="view-form gx-5 mx-auto">
              <Col lg={9}>
                <Row className="view-form-header bg-custom align-items-center">
                  <Col lg={8}>
                    Product
                    <h5>{product.name}</h5>
                  </Col>
                  <Col lg={4} className="d-flex justify-content-end">
                    <>
                      {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_PRODUCT].some(permission => {
                        return userInfo?.permissions.map(p => p.name).includes(permission);
                      }) && (
                          <Button
                            size="sm"
                            className="btn-edit mx-2"
                            onClick={() => editProduct(true)}
                          >
                            <i className="fa-regular fa-pen-to-square"></i>
                          </Button>
                        )}
                      {[PERMISSIONS.DELETE_ALL, PERMISSIONS?.DELETE_PRODUCT].some(permission => {
                        return userInfo?.permissions.map(p => p.name).includes(permission);
                      }) && (
                          <Button
                            className="btn-sm"
                            variant="danger"
                            onClick={() => setModalShow(true)}
                          >
                            <i className="fa fa-trash-o"></i>
                          </Button>
                        )}
                    </>
                  </Col>
                </Row>

                <Row className="py-3 ibs-edit-form">
                  <Col lg={6}>
                    <label>Product Name</label>
                    <span>{product.name}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Product Type</label>
                    <span>
                      <Badge bg="info">
                        {product.product_type === 'material' ? 'Material' : 'Non Material'}
                      </Badge>
                    </span>
                  </Col>
                  <Col lg={6}>
                    <label>Brand</label>
                    <span>{product.brand_name}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Status</label>
                    <span>
                      <Badge bg={product.status === "Active" ? "success" : "secondary"}>
                        {product.status}
                      </Badge>
                    </span>
                  </Col>
                  <Col lg={12}>
                    <label>Description</label>
                    <span>{product.description}</span>
                  </Col>
                  <Col lg={12}>
                    <label>Created Date</label>
                    <span>
                      {formatDateForView(product?.createddate || "")}
                    </span>
                  </Col>
                </Row>
              </Col>
            </Row>
          </>
        )}
      </Container>
    </Main>
  );
};

export default ProductView;
